import { TOGGLE_THEME } from "../constants";

function safeJSONParse(value, fallback = null) {
  try {
    return JSON.parse(value);
  } catch (e) {
    return fallback;
  }
}

const initialState = {
  darkMode: true,
};

const themeReducer = (state = initialState, action) => {
  switch (action.type) {
    case TOGGLE_THEME:
      const newDarkMode = !state.darkMode;
      localStorage.setItem("darkMode", JSON.stringify(newDarkMode));
      return {
        ...state,
        darkMode: newDarkMode,
      };

    default:
      return state;
  }
};

export default themeReducer;
